export const PRODUCT_IMPRESSION_BATCH_SIZE = 15;
export const PRODUCT_IMPRESSION_TIMEOUT_MS = 1000 * 60 * 3;
